import { Link, useLocation } from 'react-router-dom';
import { ArrowRight, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const location = useLocation();
  
  // Hide footer on landing pages
  if (location.pathname === '/lp') {
    return null;
  }

  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer Content */}
      <div className="border-b border-white/10">
        <div className="container mx-auto px-4 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12">
            
            {/* Company Info - Larger Column */}
            <div className="lg:col-span-4 space-y-6">
              <div>
                 <img src="/assets/img/brand/logo-light.png" alt="Initiate Trademark" className="h-12 mb-4" />
                <p className="text-gray-400 text-sm leading-relaxed">
                  Your trusted partner in intellectual property protection. We help businesses protect their most valuable assets with expert trademark, copyright, and patent services.
                </p>
              </div>

              {/* Contact Info */}
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 flex-shrink-0 mt-1" style={{ color: '#ff4d1b' }} />
                  <div>
                    <p className="text-sm text-gray-300">600 W Broadway Suite 700, San Diego, CA 92101</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 flex-shrink-0" style={{ color: '#ff4d1b' }} />
                  <a href="tel:+18885551234" className="text-sm text-gray-300 hover:text-white transition-colors">
                    +1 (844) 773 6722
                  </a>
                </div>
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 flex-shrink-0" style={{ color: '#ff4d1b' }} />
                  <a href="mailto:info@initiatetrademark.com" className="text-sm text-gray-300 hover:text-white transition-colors">
                    info@initiatetrademark.com
                  </a>
                </div>
              </div>
            </div>

            {/* Services Column */}
            <div className="lg:col-span-2">
              <h3 className="text-lg font-bold mb-4 text-white">Services</h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/services/trademark-registration" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" style={{ color: '#ff4d1b' }} />
                    Trademark Registration
                  </Link>
                </li>
                <li>
                  <Link to="/services/register-copyright" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" style={{ color: '#ff4d1b' }} />
                    Copyright Services
                  </Link>
                </li>
                <li>
                  <Link to="/services/patent-search" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" style={{ color: '#ff4d1b' }} />
                    Patent Services
                  </Link>
                </li>
                <li>
                  <Link to="/services/llc" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" style={{ color: '#ff4d1b' }} />
                    LLC Formation
                  </Link>
                </li>
                <li>
                  <Link to="/services/c-corporation" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" style={{ color: '#ff4d1b' }} />
                    C Corporation
                  </Link>
                </li>
                <li>
                  <Link to="/services/s-corporation" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" style={{ color: '#ff4d1b' }} />
                    S Corporation
                  </Link>
                </li>
              </ul>
            </div>

            {/* More Services */}
            <div className="lg:col-span-2">
              <h3 className="text-lg font-bold mb-4 text-white">&nbsp;</h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/services/clearance-search" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" style={{ color: '#ff4d1b' }} />
                    Clearance Search
                  </Link>
                </li>
                <li>
                  <Link to="/services/ownership-transfers" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" style={{ color: '#ff4d1b' }} />
                    Ownership Transfers
                  </Link>
                </li>
                <li>
                  <Link to="/services/office-actions" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" style={{ color: '#ff4d1b' }} />
                    Office Action Support
                  </Link>
                </li>
                <li>
                  <Link to="/services/patent-application" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" style={{ color: '#ff4d1b' }} />
                    Patent Application
                  </Link>
                </li>
                <li>
                  <Link to="/services/non-profit" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" style={{ color: '#ff4d1b' }} />
                    Non-Profit Formation
                  </Link>
                </li>
                <li>
                  <Link to="/services/bookkeeping" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" style={{ color: '#ff4d1b' }} />
                    Bookkeeping Service
                  </Link>
                </li>
              </ul>
            </div>

            {/* Company Column */}
           <div className="lg:col-span-2">
              <h3 className="text-lg font-bold mb-4 text-white">Company</h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" style={{ color: '#ff4d1b' }} />
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" style={{ color: '#ff4d1b' }} />
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" style={{ color: '#ff4d1b' }} />
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Newsletter Column */}
           <div className="lg:col-span-2">
              <h3 className="text-lg font-bold mb-4 text-white">Media Center</h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/media/blogs" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" style={{ color: '#ff4d1b' }} />
                    Blogs
                  </Link>
                </li>
                <li>
                  <Link to="/media/news-updates" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" style={{ color: '#ff4d1b' }} />
                    News & Updates
                  </Link>
                </li>
                <li>
                  <Link to="/media/publications" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" style={{ color: '#ff4d1b' }} />
                    Publications
                  </Link>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-black/30">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-gray-400">
              © {new Date().getFullYear()} Initiate Trademark. All rights reserved.
            </div>
            <div className="flex items-center gap-6 text-sm text-gray-400">
              <Link to="/privacy-policy" className="hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <span className="text-gray-600">•</span>
              <Link to="/terms-of-service" className="hover:text-white transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;